import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import DependencyManager from "../../DependencyManager";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import withConfig from "../../ComponentDependency/withConfig";
import { CalculatorScreen } from "./CalculatorScreen/CalculatorScreen";
var css = {
  "wrapper": "oalp-4siSA",
  "mobile": "oalp-3UQO3",
  "desktop": "oalp-2SsM5",
  "leftWrapper": "oalp-15IIL",
  "textBanner": "oalp-Edyh9",
  "carBanner": "oalp--dlv2",
  "formWrapper": "oalp-1rzy_"
};
import { DESKTOP } from "../../Constants/platform";
export var LoanCalculator = function LoanCalculator(_ref) {
  var data = _ref.data,
    config = _ref.config,
    CarAmountSlider = _ref.CarAmountSlider,
    withConsumerFinanceHook = _ref.withConsumerFinanceHook,
    UserDataForm = _ref.UserDataForm,
    ThankYouWidget = _ref.ThankYouWidget,
    TnCCheckbox = _ref.TnCCheckbox,
    metadata = _ref.metadata,
    track = _ref.track,
    origin = _ref.origin;
  var _data$banner = data.banner,
    carBanner = _data$banner.carBanner,
    textBanner = _data$banner.textBanner;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var WrappedHoc = useMemo(function () {
    return withConsumerFinanceHook(CalculatorScreen);
  }, [withConsumerFinanceHook]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.wrapper, css[PanameraConstants.platform])
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.leftWrapper, css[PanameraConstants.platform])
  }, textBanner && /*#__PURE__*/React.createElement(ImageWrapper, {
    className: css.textBanner,
    image: {
      url: textBanner.url,
      style: textBanner.style
    }
  }), carBanner && carBanner.url && /*#__PURE__*/React.createElement(ImageWrapper, {
    className: classnames(_defineProperty({}, css.carBanner, PanameraConstants.platform === DESKTOP)),
    image: carBanner
  })), /*#__PURE__*/React.createElement(WrappedHoc, {
    data: data,
    metadata: metadata,
    handoverToClFlow: data.handoverToClFlow,
    config: config,
    CarAmountSlider: CarAmountSlider,
    UserDataForm: UserDataForm,
    ThankYouWidget: ThankYouWidget,
    TnCCheckbox: TnCCheckbox,
    onTrack: track,
    origin: origin
  }));
};
export default compose(withComponentDependency, withConfig)(LoanCalculator);